import { Result, Button, Space } from "antd";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const navigateToHome = () => {
    navigate("/");
  };

  const goBack = () => {
    navigate(-1); // To go back to the previous page
  };

  return (
    <Result
      status="404"
      title="Oops! Page Not Found"
      subTitle="Sorry, the page you visited does not exist. Please check the URL or go back to the homepage."
      extra={
        <Space>
          <Button type="primary" onClick={navigateToHome}>
            Back to Home
          </Button>
          <Button onClick={goBack}>Go Back</Button>
        </Space>
      }
    />
  );
};

export default NotFoundPage;
